module.exports = __webpack_public_path__ + "media/images/pc/specials/common/store_kyoto-58b4cb97e838e04ce5cb0475929895c0.jpg";